import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { formatDistanceToNow } from 'date-fns';
import { EstateWorkItemNote_FieldsFragment, useUser_GetUserByIdQuery } from 'queries';

import Spinner from 'common/spinner';
import UserAvatar from 'common/user-avatar';
import { NotificationSeverity, showAlert } from 'utils/notification-manager';

const useStyles = makeStyles(() => ({
  container: {
    fontSize: '14px',
    marginBottom: '30px',
    marginTop: '20px',
    paddingBottom: '20px',
    borderBottom: '1px solid #E0E0E0',
  },
  header: {
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
    '& .userName': {
      marginRight: '16px',
    },
  },
}));

type Props = {
  estateWorkItemNote: EstateWorkItemNote_FieldsFragment;
};

const AssignedTaskNote = ({ estateWorkItemNote }: Props) => {
  const classes = useStyles();

  const { data: userData, loading: loadingUserData } = useUser_GetUserByIdQuery({
    skip: estateWorkItemNote.fromTSA,
    variables: { id: estateWorkItemNote.userId || '' },
    onError: (e) => {
      showAlert({
        message: 'Error getting user by ID: ' + e.message,
        severity: NotificationSeverity.ERROR,
      });
    },
  });

  if (loadingUserData) {
    return <Spinner />;
  }

  const firstName = estateWorkItemNote.fromTSA
    ? 'Trustate'
    : `${userData?.data.firstName} ${userData?.data.lastName.charAt(0)}.`;

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <UserAvatar firstName={firstName} avatarUrl={userData?.data.avatarUrl} size="sm" />
        <div className="userName">{firstName}</div>
        <div>
          {formatDistanceToNow(new Date(estateWorkItemNote.createdAt), { addSuffix: true })}
        </div>
      </div>
      <Typography>{estateWorkItemNote.note}</Typography>
    </div>
  );
};

export default AssignedTaskNote;
